export default Object.freeze({
  ELECTRICITY: 'electricity',
  GAS: 'gas'
});



// WEBPACK FOOTER //
// ./src/enums/modules/energyEnum.js